import { RiSearch2Line } from 'react-icons/ri';
import '../../style/mobile/home/MH_Search.scss';
import icon1 from '../../../assets/mobile/home/home-trend-up.svg';

const MH_Search=()=>{
  return(
    <div className="Mh-Search">
      <div className="Mh-Search-box">
        <RiSearch2Line className="Mh-Search-box-icon"/>
        <input type="search" name="Mh-Search-box-input" id="Mh-Search-box-input-id"/>
      </div>
      <div className="Mh-Search-tags">
        <img src={icon1} alt="tags-icon"/>
        <div className="Mh-Search-tags-item">محبوب‌ترین‌ها</div>
        <div className="Mh-Search-tags-item">پرفروش‌ترین ها</div>
        <div className="Mh-Search-tags-item">هنر</div>
      </div>
    </div>
  )
}

export default MH_Search;